import { mapGetters, mapActions, mapState } from 'vuex'
import moment from 'moment'

export default {
  computed: {
    ...mapState({
      dicts: state => state.dict.dicts
    })
  },
  filters: {
    dateFilter (string, type = 'YYYY/MM/DD HH:mm:ss') {
      if (!string) {
        return ''
      }
      return moment(string).format(type)
    }
  },
  methods: {
    ...mapActions({ 'getDictByKey': 'getDictByKey'}),
    dictFilter (val, feild, key = 'dictValue', labelKey = 'dictLabel') {
      if (!this.dicts[feild] || !this.dicts[feild].length) {
        this.getDictByKey(feild)
        setTimeout(() => {
          const options = (this.dicts[feild] || [])
          const item = options.find(x => String(x[key]) === String(val))
          return item ? item[labelKey] : val
        }, 1000)
      } else {
        const options = (this.dicts[feild] || [])
        const item = options.find(x => String(x[key]) === String(val))
        return item ? item[labelKey] : val
      }
    }
  }
}
